import type { OverviewResponse } from "contracts/api/dashboard/responses";
import { hasUnrelatedBrandReference } from "../tov/guidelineModel";

/** Keeps generated copy only when it belongs to the current site. */
export function siteSpecificText(
  data: OverviewResponse,
  text: string | null | undefined,
): string | null {
  if (!text) return null;
  return hasUnrelatedBrandReference(data.site, text) ? null : text;
}
